// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Handgezeichnete Icon-Familie (Skill §6): Tanne-Kontur, runde Enden, keine Icon-Bibliothek.
// Alle stroke=currentColor, damit aktiv/inaktiv über Farbe läuft.

interface IconProps { size?: number }

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.9,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
})

/** Kurzhantel — Training */
export function IconHantel({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <path d="M8.5 12h7" />
      <rect x="4.6" y="8.4" width="2.6" height="7.2" rx="1.1" />
      <rect x="16.8" y="8.4" width="2.6" height="7.2" rx="1.1" />
      <path d="M2.6 10.4v3.2M21.4 10.4v3.2" />
    </svg>
  )
}

/** Hütte mit Rauch — Start */
export function IconHuette({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <path d="M3.4 10.6 12 4l8.6 6.6" />
      <path d="M5.4 9.6v9.8h13.2V9.6" />
      <path d="M9.8 19.4v-4.9h4.4v4.9" />
    </svg>
  )
}

/** Stift über Linie — Eintragen */
export function IconStift({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <path d="M5.5 15.2 15.4 5.3a1.9 1.9 0 0 1 2.7 0l.6.6a1.9 1.9 0 0 1 0 2.7l-9.9 9.9-4 1.3z" />
      <path d="M4 20.8h16" />
    </svg>
  )
}

/** Zeilen mit Punkten — Verlauf */
export function IconVerlauf({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <circle cx="5" cy="6.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="5" cy="12" r="1" fill="currentColor" stroke="none" />
      <circle cx="5" cy="17.5" r="1" fill="currentColor" stroke="none" />
      <path d="M9 6.5h10M9 12h10M9 17.5h6.5" />
    </svg>
  )
}

/** Spross — Fortschritt */
export function IconSpross({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <path d="M12 20.5V11" />
      <path d="M12 12.5c0-3.4 2.2-5.6 5.6-5.6 0 3.4-2.2 5.6-5.6 5.6z" />
      <path d="M12 9.8C12 7.2 10.3 5.5 7.7 5.5c0 2.6 1.7 4.3 4.3 4.3z" />
      <path d="M7.5 20.5h9" />
    </svg>
  )
}

/** Klemmbrett — Plan */
export function IconPlan({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <rect x="5.5" y="4.5" width="13" height="16" rx="2.2" />
      <path d="M9.5 4.5V3.4h5v1.1" />
      <path d="M9 10h6.5M9 13.5h6.5M9 17h4" />
    </svg>
  )
}

/** Glühwürmchen-Funke — Feed */
export function IconFunke({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <circle cx="14.5" cy="9.5" r="3.2" />
      <path d="M12.2 12.2c-2.4 2.4-4.8 4-7.4 4.9" strokeDasharray="0.1 3" />
      <path d="M14.5 3.6v1.3M19.7 6.2l-.9.9M20.4 11.9h-1.3" />
    </svg>
  )
}

/** Kopf im Kreis — Profil */
export function IconProfil({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <circle cx="12" cy="12" r="8.6" />
      <circle cx="12" cy="10" r="2.6" />
      <path d="M6.8 18.2c1-2.2 2.9-3.4 5.2-3.4s4.2 1.2 5.2 3.4" />
    </svg>
  )
}

/** Papierkorb — Löschen (Verlauf) */
export function IconPapierkorb({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <path d="M6.6 7.5l.8 11a2 2 0 0 0 2 1.9h5.2a2 2 0 0 0 2-1.9l.8-11" />
      <path d="M4.6 6.4h14.8" />
      <path d="M9.7 6.2a2.3 2.3 0 0 1 4.6 0" />
      <path d="M10.1 10.5v5.6M13.9 10.5v5.6" />
    </svg>
  )
}

/** Sanduhr — Eintrag wartet auf Sync */
export function IconSanduhr({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <path d="M6.8 3.8h10.4M6.8 20.2h10.4" />
      <path d="M8.4 3.8v2.9c0 2.7 3.6 3.5 3.6 5.3s-3.6 2.6-3.6 5.3v2.9" />
      <path d="M15.6 3.8v2.9c0 2.7-3.6 3.5-3.6 5.3s3.6 2.6 3.6 5.3v2.9" />
      <path d="M10.3 18.4c.5-1.2 1.1-1.8 1.7-1.8s1.2.6 1.7 1.8z" fill="currentColor" stroke="none" />
    </svg>
  )
}

/** Flamme — Feed-Reaktion „Feuer" */
export function IconFlamme({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <path d="M12.3 3.6c1.1 2.7 4.5 4.3 4.5 7.9a4.9 4.9 0 0 1-9.8.2c0-1.6.7-3 1.7-4.3.3 1 .8 1.7 1.6 2.2-.4-2.2.5-4.3 2-6z" />
      <path d="M12 17.4a2.1 2.1 0 0 0 2.1-2.1c0-1-.8-1.7-1.4-2.6-.6.9-2.8 1.5-2.8 2.8a2.1 2.1 0 0 0 2.1 1.9z" />
    </svg>
  )
}

/** Angewinkelter Arm (Bizeps) — Feed-Reaktion „Stark" */
export function IconArm({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <path d="M12.4 13a5 5 0 0 1 9.6 2c0 3.9-4 7-9 7-4.1 0-8.2-.8-10.4-2.5-.4-.3-.6-.8-.6-1.4C2.1 12.7 2.6 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.1 0-1.6-.4-2-1" />
    </svg>
  )
}

/** Abklatschende Hand — Feed-Reaktion „Applaus" */
export function IconKlatschen({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <path d="M18.2 11.4V6.6a1.8 1.8 0 0 0-3.6 0v4.4" />
      <path d="M14.6 10.6V5a1.8 1.8 0 0 0-3.6 0v2" />
      <path d="M11 11V6.8a1.8 1.8 0 0 0-3.6 0v7.6" />
      <path d="m7.4 15.4-1.6-1.6a1.8 1.8 0 0 0-2.6 2.6l3.4 3.4a7.3 7.3 0 0 0 12.6-5v-2.7a1.8 1.8 0 0 0-3.6 0" />
      <path d="M4.4 7.2 3 5.8M6.3 4.6l-.7-1.8" />
    </svg>
  )
}

/** Lautsprecher — Timer-Ton an/aus */
export function IconLautsprecher({ size = 24, aus = false }: IconProps & { aus?: boolean }) {
  return (
    <svg {...base(size)}>
      <path d="M4.6 9.8v4.4h3l4.2 3.6V6.2L7.6 9.8z" />
      {aus ? (
        <path d="M15.4 9.9l4.4 4.4M19.8 9.9l-4.4 4.4" />
      ) : (
        <>
          <path d="M15.4 9.7a3.6 3.6 0 0 1 0 4.6" />
          <path d="M17.7 7.7a6.6 6.6 0 0 1 0 8.6" />
        </>
      )}
    </svg>
  )
}

/** Stoppuhr — Intervall-Timer im Plan-Editor */
export function IconStoppuhr({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <circle cx="12" cy="13.4" r="6.6" />
      <path d="M12 6.8V4.4M10 4h4" />
      <path d="M12 13.4l2.5-2.2" />
      <path d="M17.6 8.3l1.2-1.2" />
    </svg>
  )
}

/** Gefühls-Gesichter (§6-Familie statt Emoji): stark/gut/okay/zäh/schmerz */
export function FeelFace({ feel, size = 24 }: IconProps & { feel: string }) {
  return (
    <svg {...base(size)}>
      <circle cx="12" cy="12" r="8.8" />
      {feel === "stark" && (
        <>
          <path d="M7.6 9.4l2.6-.9M16.4 9.4l-2.6-.9" />
          <circle cx="9.4" cy="11" r="0.55" fill="currentColor" />
          <circle cx="14.6" cy="11" r="0.55" fill="currentColor" />
          <path d="M8.4 14.2c1.1 1.7 2.3 2.5 3.6 2.5s2.5-.8 3.6-2.5" />
        </>
      )}
      {feel === "gut" && (
        <>
          <circle cx="9.3" cy="10.4" r="0.55" fill="currentColor" />
          <circle cx="14.7" cy="10.4" r="0.55" fill="currentColor" />
          <path d="M8.8 14.1c1 1.3 2 1.9 3.2 1.9s2.2-.6 3.2-1.9" />
        </>
      )}
      {feel === "okay" && (
        <>
          <circle cx="9.3" cy="10.4" r="0.55" fill="currentColor" />
          <circle cx="14.7" cy="10.4" r="0.55" fill="currentColor" />
          <path d="M9.2 14.9h5.6" />
        </>
      )}
      {feel === "zäh" && (
        <>
          <path d="M8.2 9.6h2.2M13.6 9.6h2.2" />
          <circle cx="9.3" cy="11" r="0.55" fill="currentColor" />
          <circle cx="14.7" cy="11" r="0.55" fill="currentColor" />
          <path d="M8.8 15.3c.8-.8 1.6-.8 2.3 0 .7.8 1.5.8 2.3 0 .7-.8 1.5-.8 2.3 0" />
        </>
      )}
      {feel === "schmerz" && (
        <>
          <path d="M8.5 9.9l1.7 1.7M10.2 9.9l-1.7 1.7" />
          <path d="M13.8 9.9l1.7 1.7M15.5 9.9l-1.7 1.7" />
          <path d="M8.8 15.9c1-1.3 2-1.9 3.2-1.9s2.2.6 3.2 1.9" />
        </>
      )}
    </svg>
  )
}

/** Filmklappe mit Play — Video-Suche zu einer Übung */
export function IconVideo({ size = 24 }: IconProps) {
  return (
    <svg {...base(size)}>
      <rect x="2.8" y="6.4" width="18.4" height="12.2" rx="2.4" />
      <path d="M2.8 10.2h18.4" />
      <path d="M6.6 6.6 8.4 10M11.2 6.6 13 10M15.8 6.6 17.6 10" />
      <path d="M10.4 12.6v3.6l3.4-1.8z" />
    </svg>
  )
}
